<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import CheckMore from '../common/CheckMore.vue'

import { getShadowColor, getPageThemeColor } from '@/utils/modules/getStyles'

export default {
  name: 'Comp18',
  components: { ModuleTitle, CheckMore },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: { getShadowColor, getPageThemeColor }
}
</script>

<template>
  <div class="modules-id-18">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-3 modules-id-18-content pointer">
      <div
        :style="{boxShadow: `0 3px 17px 0 ${getShadowColor(path)}`}"
        class="main-content"
      >
        <div class="img-group">
          <el-image
            v-for="v in moduleOption.list.slice(0, 4)"
            :key="`modules-18-${v.id}`"
            :src="v.photo | imgPath"
            alt="work"
            class="item-img"
            fit="cover"
          />
        </div>
        <check-more class="check-more-18" mode="2" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-18-content {
  height: 100%;
  display: flex;
}
.main-content {
  width: 443px;
  height: 328px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  .img-group {
    width: 430px;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin: 12px 0 0 12px;
    .item-img {
      width: 204px;
      height: 121px;
      border-radius: 5px;
    }
  }
}
.check-more-18 {
  margin-top: 12px;
}

</style>
